// extracted by extract-css-chunks-webpack-plugin
module.exports = {"list":"tabs__list--2vDBI","item":"tabs__item--1IvRI","link":"tabs__link--1ss3G","active":"tabs__active--1WYRb"};